import React from "react";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { TheCycleverseTheme } from "src/theme";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  scrollDownBtnContainer: {
    textAlign: "center",
    marginBottom: "30px",
    cursor: "pointer",
  },

  buttonStyles: {
    backgroundColor: theme.buttonBackgroundColor,
    color: theme.buttonColor,
    width: "180px",
  },
}));

export const CalculatorButtonWithWidth = ({ calculate, btnText }) => {
  const classes = useStyles();
  return (
    <div className={classes.scrollDownBtnContainer}>
      <Button className={classes.buttonStyles} onClick={calculate}>
        {btnText}
      </Button>
    </div>
  );
};
